import React, { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GET_AUTH_DATA } from '../graphql/actions/auth.js';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
// core components
import Header from '../components/UI/Header/Header';
import HeaderLinks from '../components/UI/Header/HeaderLinks';
import Parallax from '../components/UI/Parallax/Parallax';
import GridContainer from '../components/UI/Grid/GridContainer';
import GridItem from '../components/UI/Grid/GridItem';
import Footer from '../components/UI/Footer/Footer';

import usuarioLayoutStyle from '../assets/jss/coscef/layouts/usuarioLayoutStyle';
// img
import bg01 from '../assets/img/bg01.jpg';
import profile01 from '../assets/img/profile01.jpg';
//import profile02 from '../assets/img/profile02.jpg';

const useStyles = makeStyles(usuarioLayoutStyle);

const UsuarioLayout = (props) => {
  // styles
  const classes = useStyles();

  useEffect(() => {
    document.body.style.overflow = 'unset';
    // Specify how to clean up after this effect:
    return function cleanup() {};
  }, []);

  const {
    data: { getAuthData },
  } = useQuery(GET_AUTH_DATA);

  return (
    <div>
      <Header
        brand='CoScef'
        links={
          <HeaderLinks
            dropdownHoverColor='dark1'
            isAuth={getAuthData.isLoggedIn}
          />
        }
        fixed
        color='transparent'
        changeColorOnScroll={{
          height: 100,
          color: 'dark',
        }}
      />
      <Parallax image={bg01} filter='dark' className={classes.parallax}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                {/* <h1>CoScef</h1> */}
                <h3 className={classes.title}>
                  Consultoría de Servicios Contables, Económicos y Financieros.
                </h3>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      {props.children}
      <Footer
        theme='dark'
        content={
          <div className={classNames(classes.pullCenter, classes.copyRight)}>
            &copy; {1900 + new Date().getYear()}{' '}
            <a href='https://www.coscef.co.cu' className={classes.aClasses}>
              <b>CoScef</b>
            </a>{' '}
            Todos los Derechos Reservados.
          </div>
        }
      >
        <GridContainer>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Contactenos a través de:</h5>
            <div className={classes.socialFeed}>
              <div>
                <i className='fa fa-phone-square fa-lg' />
                <p>24 480558, 53784162 y 58396621</p>
              </div>
              <div>
                <i className='fab fa-whatsapp' />
                <p>53784162 y 58396621</p>
              </div>
              <div>
                <i className='fa fa-envelope-square fa-lg' />
                <p>elbalan@nauta.cu o elbalan65@gmail.com</p>
              </div>
            </div>
            <p>
              Marcando la diferencia a partir de los atributos: Experiencia,
              Competitividad, Calidad y Liderazgo.{' '}
            </p>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Redes sociales</h5>
            <div className={classes.socialFeed}>
              <div>
                <i className='fab fa-facebook-square' />
                <p>Canal de facebook.</p>
              </div>
              <div>
                <i className='fab fa-telegram' />
                <p>Canal de telegram.</p>
              </div>
              <div>
                <i className='fab fa-twitter' />
                <p>Canal de twitter.</p>
              </div>
            </div>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Grupo de trabajo</h5>
            <div className={classes.galleryFeed}>
              <img
                src={profile01}
                className={classNames(
                  classes.img,
                  classes.imgRaised,
                  classes.imgRounded
                )}
                alt='...'
              />
              {/* <img
                src={profile02}
                className={classNames(
                  classes.img,
                  classes.imgRaised,
                  classes.imgRounded
                )}
                alt='...'
              /> */}
            </div>
          </GridItem>
        </GridContainer>
      </Footer>
    </div>
  );
};

export default UsuarioLayout;
